import { uploadUrl } from "../../lib/assets";
import {
  getBlogArticleMeta,
  getBlogPostBody,
  getRelatedBlogPosts,
} from "../../data/blog";
import StoryContent from "../stories/StoryContent";
import BlogCard from "./BlogCard";

const DEFAULT_AUTHOR_BIO =
  "Photographer, storyteller, explorer. Builds products by day, chases stories the rest of the time.";

/**
 * @param {{ post: { id: string, title: string, cat: string, img: string, date: string, read: string, short: string, blurb: string, kw: string, featured?: boolean }, onBack: () => void }} props
 */
export default function BlogArticle({ post, onBack }) {
  const related = getRelatedBlogPosts(post.id);
  const body = getBlogPostBody(post.id);
  const articleMeta = getBlogArticleMeta(post.id);
  const heroImg = uploadUrl(post.img);
  const heroCaption =
    articleMeta?.heroCaption ?? `[ ${post.cat.toLowerCase()} ]`;
  const eyebrow = articleMeta?.eyebrow ?? `${post.cat.toUpperCase()} · FIELD NOTES`;
  const tags = articleMeta?.tags ?? post.kw.split(" ").slice(0, 4);
  const authorBio = articleMeta?.authorBio ?? DEFAULT_AUTHOR_BIO;

  return (
    <article className="blog-article">
      <div
        className="blog-article__hero"
        style={{ backgroundImage: `url('${heroImg}')` }}
      >
        <div className="blog-article__hero-scrim" />
        <div className="blog-article__hero-content">
          <div className="blog-article__eyebrow">{eyebrow}</div>
          <h1 className="blog-article__title">{post.title}</h1>
          <div className="blog-article__byline">
            <span>CJ JAYAMAHA</span>
            <span aria-hidden="true">·</span>
            <span>{post.date}</span>
            <span aria-hidden="true">·</span>
            <span>{post.read}</span>
          </div>
        </div>
        <span className="blog-article__hero-caption">{heroCaption}</span>
      </div>

      <div className="blog-article__back-wrap">
        <button type="button" className="blog-article__back" onClick={onBack}>
          ← THE BLOG
        </button>
      </div>

      {body ? <StoryContent body={body} /> : null}

      <div className="blog-article__footer">
        <div className="blog-article__tags">
          {tags.map((tag) => (
            <span key={tag} className="blog-article__tag">
              #{tag.replace(/^#/, "")}
            </span>
          ))}
        </div>

        <div className="blog-article__author">
          <div
            className="blog-article__author-avatar"
            style={{
              backgroundImage: `url('${uploadUrl("cjmeister-com-_DSC6660-Edit.jpg")}')`,
            }}
          />
          <div>
            <div className="blog-article__author-name">CJ Jayamaha</div>
            <p className="blog-article__author-bio">{authorBio}</p>
          </div>
        </div>
      </div>

      {related.length > 0 ? (
        <section className="blog-article__related" aria-label="Keep reading">
          <div className="blog-article__related-label">KEEP READING</div>
          <div className="blog-article__related-grid">
            {related.map((relatedPost) => (
              <BlogCard key={relatedPost.id} post={relatedPost} query="" compact />
            ))}
          </div>
        </section>
      ) : null}
    </article>
  );
}
